module.exports = __webpack_public_path__ + "img/logo_typo.cb48e2f1.png";